module.exports = __webpack_public_path__ + "static/img/empty-01.7eefe85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-01.png
// module id = 10
// module chunks = 7